import { render } from "./index.vue?vue&type=template&id=aaea0df8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=aaea0df8&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-aaea0df8"

export default script